<template>
  <div id="chart">
    <VueApexCharts type="line" ref="chart" width="100%" height="100%" :options="chartOptions" :series="series"> </VueApexCharts>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { getColorVoltage } from "../../../colors.js";

export default {
  name: "ApexBarChart",
  components: {
    VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      require: true,
    },
    dataLine: {
      type: Array,
      require: true,
    },
    dataOV: {
      type: Array,
      require: true,
    },
    dataUV: {
      type: Array,
      require: true,
    },
    dataHOV: {
      type: Array,
      require: true,
    },
    dataHUV: {
      type: Array,
      require: true,
    },
    dataBalancing: {
      type: Array,
      require: true,
    },
    label: {
      type: Array,
      require: true,
    },
    type: {
      type: String,
      require: true,
    },
    dark: {
      type: Boolean,
      require: true,
    },
    /*     width: {
      type: String,
      require: true,
    }, */
  },

  data: () => ({
    timer: null,

    shadeTo: "light",
    mode: "light",

    series: [
      {
        name: "Voltage",
        data: [],
      },
    ],
    chartOptions: {
      colors: [
        function ({ value, seriesIndex, w }) {
          if (value > 3.85) {
            return "#DD2C00";
          } else if (value > 3.65) {
            return "#FF5722";
          } else if (value > 2.85) {
            return "#8BC34A";
          } else if (value > 2.65) {
            return "#03A9F4";
          } else {
            return "#00BCD4";
          }
        },
        "#8BC34A",
        "#03A9F4",
        "#FF5722",
        "#00BCD4",
        "#DD2C00",
      ],
      states: {
        normal: {
          filter: {
            type: "none",
          },
        },
        hover: {
          filter: {
            type: "none",
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: "none",
          },
        },
      },
      legend: {
        show: false,
      },
      stroke: {
        width: [0, 1, 1, 1, 1, 1, 1],
        dashArray: [0, 0, 4, 4, 12, 12, 0],
      },
      chart: {
        stacked: false,
        height: 160,
        type: "bar",
        background: "#00000000",
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
        toolbar: {
          show: false,
          tools: {
            download: false,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
          },
        },
        zoom: { enabled: false },
      },
      fill: {
        type: "solid",
      },
      markers: {
        size: [0, 0, 0, 0, 0, 0, 10],
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: "bottom", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabledOnSeries: [0],
        enabled: false,
        formatter: function (val) {
          return val + " V";
        },
        offsetY: -30,
        style: {
          fontSize: "9px",
          colors: ["#304758", "#304758"],
        },
      },
      tooltip: { enabled: false },
      grid: {
        show: false,
      },
      xaxis: {
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: true,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 26,
          style: {
            colors: ["FFFFFF"],
            fontSize: "10px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-xaxis-label",
          },
          offsetX: 2,
          offsetY: 0,
        },
        categories: [],
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: false,
        },
      },
      yaxis: {
        max: 4,
        min: 2.0,
        tickAmount: 2,

        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: true,
        },
        labels: {
          show: true,
          formatter: function (val) {
            return Math.round(val * 100) / 100 + " V";
          },
        },
      },
    },
  }),
  created() {},
  mounted() {
    this.updateChart();
    this.setTheme();
    this.setType();
  },
  methods: {
    getColorVoltage,
    updateChart() {
      this.series = [];

      for (let index = 0; index < this.data.length; index++) {
        if (this.data[index] < 0) {
          this.data = 0;
        }
      }

      this.series = [
        {
          name: "Voltage",
          type: "bar",
          data: this.data == undefined ? [] : this.data,
        },
        {
          name: "Average",
          type: "line",
          data: this.dataLine == undefined ? [] : this.dataLine,
          fillColor: "#EB8C87",
          strokeColor: "#C23829",
        },
        {
          name: "UV",
          type: "line",
          data: this.dataUV == undefined ? [] : this.dataUV,
          fillColor: "#EB8C87",
          strokeColor: "#C23829",
        },
        {
          name: "OV",
          type: "line",
          data: this.dataOV == undefined ? [] : this.dataOV,
          fillColor: "#EB8C87",
          strokeColor: "#C23829",
        },
        {
          name: "HUV",
          type: "line",
          data: this.dataHUV == undefined ? [] : this.dataHUV,
          fillColor: "#EB8C87",
          strokeColor: "#C23829",
        },
        {
          name: "HOV",
          type: "line",
          data: this.dataHOV == undefined ? [] : this.dataHOV,
          fillColor: "#EB8C87",
          strokeColor: "#C23829",
        },
        {
          name: "Balancing",
          type: "scatter",
          data: this.dataBalancing == undefined ? [] : this.dataBalancing, //[2.14, 2.19, 2.14, 2.14, 2.14, 2.14, 2.14, 2.14, 2.14, 2.14, 2.14, 2.14],
          fillColor: "#EB8C87",
          strokeColor: "#C23829",
        },
      ];

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          xaxis: {
            categories: this.label,
            position: "top",
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            crosshairs: {
              fill: {
                type: "gradient",
                gradient: {
                  colorFrom: "#D8E3F0",
                  colorTo: "#BED1E6",
                  stops: [0, 100],
                  opacityFrom: 0.4,
                  opacityTo: 0.5,
                },
              },
            },
            tooltip: {
              enabled: false,
            },
          },
        },
      };

      if (this.type == "Voltage") {
        this.chartOptions = {
          ...this.chartOptions,
          ...{
            colors: [
              function ({ value, seriesIndex, w }) {
                if (value > 3.85) {
                  return "#DD2C00";
                } else if (value > 3.65) {
                  return "#FF5722";
                } else if (value > 2.85) {
                  return "#8BC34A";
                } else if (value > 2.65) {
                  return "#03A9F4";
                } else {
                  return "#00BCD4";
                }
              },
              "#8BC34A",
              "#03A9F4",
              "#FF5722",
              "#00BCD4",
              "#DD2C00",
              "#FF9800",
            ],
          },
        };
      }

      /* this.$refs.chart.refresh(); */
    },
    setTheme() {
      if (this.dark === true) {
        this.shadeTo = "dark";
        this.mode = "dark";
        this.updateTheme();
      } else {
        this.shadeTo = "light";
        this.mode = "light";
        this.updateTheme();
      }
    },
    setType() {
      if (this.type === "Voltage") {
        this.chartOptions = {
          ...this.chartOptions,
          ...{},
        };
      }
    },
    updateTheme() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.mode,
            palette: "palette8",
            monochrome: {
              enabled: false,
              color: "#F9C80E",
              shadeTo: this.shadeTo,
              shadeIntensity: 0.25,
            },
          },
        },
      };

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          chart: {
            stacked: false,
            height: 160,
            type: "bar",
            background: "#00000000",
            animations: {
              enabled: false,
              animateGradually: {
                enabled: false,
              },
              dynamicAnimation: {
                enabled: false,
              },
            },
            toolbar: {
              show: false,
              tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
              },
            },
            zoom: { enabled: false },
          },
        },
      };

      this.chartOptions = {
        ...this.chartOptions,
        ...{
          dataLabels: {
            enabledOnSeries: [0],
            enabled: false,
            formatter: function (val) {
              return val + " V";
            },
            offsetY: 0,
            style: {
              fontSize: "9px",
              colors: this.dark == true ? ["#FFFFFF"] : ["#000000"],
            },
          },
        },
      };
    },
  },
  watch: {
    data: function () {
      this.updateChart();
    },
    dark: function () {
      this.setTheme();
    },
  },
};
</script>

<style scoped></style>
